'use client';

import { Loading } from 'components';
import { toaster } from 'helpers/toaster';
import { useTranslations } from 'next-intl';
import { useRouter } from 'next/navigation';
import { useCallback, useEffect } from 'react';
import { notifyException } from 'services/appsignal';

interface IErrorPage {
  error: Error;
  reset: () => void;
}

export default function ErrorPage({ error }: IErrorPage) {
  const t = useTranslations();
  const router = useRouter();

  const handleError = useCallback(async () => {
    notifyException(error);
    toaster.error(t('messages.error.something_happen'));
    router.push('/');
  }, [error, router, t]);

  useEffect(() => {
    handleError();
  }, [handleError]);

  return <Loading />;
}
